import * as React from 'react';
import { IProject } from 'application/project/api/Project';
import EditIcon from '@mui/icons-material/Edit';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    color: `${theme.palette.text.secondary} !important`,

    width: '100%',
    marginTop: theme.spacing(2),
  },
  button: {
    float: 'right',
  },
}));

export const ProjectItem = (props: {
  project: IProject;
  editProject: (project: IProject) => any;
  copyProject: (project: IProject) => any;
  deleteProject: (project: IProject) => any;
}) => {
  const classes = useStyles();
  const { editProject, copyProject, deleteProject } = props;
  const { t } = useTranslation(['project']);

  const date = new Date(props.project.date);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Grid container spacing={3}>
          <Grid item xs={8}>
            <div>
              <div>
                <h3>{props.project?.title}</h3>
                {t('projectDateFormat', '{{val, shortdate}}', {
                  val: date,
                })}
              </div>
              <div>{props.project?.description}</div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <IconButton
              className={classes.button}
              color="primary"
              title={t('editbuttontitle', 'edit project')}
              onClick={React.useCallback(
                (event: any) => {
                  event.preventDefault();
                  event.stopPropagation();
                  editProject(props.project);
                },
                [editProject, props?.project]
              )}>
              <EditIcon />
            </IconButton>
            <IconButton
              className={classes.button}
              color="primary"
              title={t('copybuttontitle', 'copy project')}
              onClick={React.useCallback(
                (event: any) => {
                  event.preventDefault();
                  event.stopPropagation();
                  copyProject(props.project);
                },
                [copyProject, props.project]
              )}>
              <FileCopyIcon />
            </IconButton>
            <IconButton
              className={classes.button}
              color="primary"
              title={t('deletebuttontitle', 'delete project')}
              onClick={React.useCallback(
                (event: any) => {
                  event.preventDefault();
                  event.stopPropagation();
                  deleteProject(props.project);
                },
                [deleteProject, props.project]
              )}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default ProjectItem;
